export default{
  setCities: (state, payload) => {state.cities = payload},
  setCity: (state, payload) => {state.city = payload},
  // setDistricts: (state, payload) => {state.districts = payload},
  // setDistrict: (state, payload) => {state.district = payload},
}